/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Badge_GoneInputs */

const id_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilang`)
};

const ms_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilang`)
};

const da_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Væk`)
};

const de_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weg`)
};

const en_us2_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gone`)
};

const es_es2_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminado`)
};

const es_mx2_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminado`)
};

const fil_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala na`)
};

const fr_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimé`)
};

const it_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimosso`)
};

const hu_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eltűnt`)
};

const nl_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdwenen`)
};

const no_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fjernet`)
};

const pl_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usunięte`)
};

const pt_br2_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdido`)
};

const pt_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removido`)
};

const ro_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminat`)
};

const fi_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poistettu`)
};

const sv_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borttagen`)
};

const vi_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã biến mất`)
};

const tr_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gitmiş`)
};

const cs_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pryč`)
};

const bg_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премахнато`)
};

const ru_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалено`)
};

const uk_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видалено`)
};

const ar_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مختفي`)
};

const hi_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गया`)
};

const th_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หายไป`)
};

const ja_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

const zh_cn2_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const zh_hant1_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const ko_home_pulse_badge_gone = /** @type {(inputs: Home_Pulse_Badge_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사라짐`)
};

/**
* | output |
* | --- |
* | "Gone" |
*
* @param {Home_Pulse_Badge_GoneInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_badge_gone = /** @type {((inputs?: Home_Pulse_Badge_GoneInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Badge_GoneInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_badge_gone(inputs)
	if (locale === "ms") return ms_home_pulse_badge_gone(inputs)
	if (locale === "da") return da_home_pulse_badge_gone(inputs)
	if (locale === "de") return de_home_pulse_badge_gone(inputs)
	if (locale === "en-US") return en_us2_home_pulse_badge_gone(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_badge_gone(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_badge_gone(inputs)
	if (locale === "fil") return fil_home_pulse_badge_gone(inputs)
	if (locale === "fr") return fr_home_pulse_badge_gone(inputs)
	if (locale === "it") return it_home_pulse_badge_gone(inputs)
	if (locale === "hu") return hu_home_pulse_badge_gone(inputs)
	if (locale === "nl") return nl_home_pulse_badge_gone(inputs)
	if (locale === "no") return no_home_pulse_badge_gone(inputs)
	if (locale === "pl") return pl_home_pulse_badge_gone(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_badge_gone(inputs)
	if (locale === "pt") return pt_home_pulse_badge_gone(inputs)
	if (locale === "ro") return ro_home_pulse_badge_gone(inputs)
	if (locale === "fi") return fi_home_pulse_badge_gone(inputs)
	if (locale === "sv") return sv_home_pulse_badge_gone(inputs)
	if (locale === "vi") return vi_home_pulse_badge_gone(inputs)
	if (locale === "tr") return tr_home_pulse_badge_gone(inputs)
	if (locale === "cs") return cs_home_pulse_badge_gone(inputs)
	if (locale === "bg") return bg_home_pulse_badge_gone(inputs)
	if (locale === "ru") return ru_home_pulse_badge_gone(inputs)
	if (locale === "uk") return uk_home_pulse_badge_gone(inputs)
	if (locale === "ar") return ar_home_pulse_badge_gone(inputs)
	if (locale === "hi") return hi_home_pulse_badge_gone(inputs)
	if (locale === "th") return th_home_pulse_badge_gone(inputs)
	if (locale === "ja") return ja_home_pulse_badge_gone(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_badge_gone(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_badge_gone(inputs)
	return ko_home_pulse_badge_gone(inputs)
});
export { home_pulse_badge_gone as "home.pulse.badge.gone" }